/* AP Club conversion layer.
   Cross-sell copy cleanup only — delivery/shipping messaging is handled by Shopify content
   directly (announcement bar text, product description, cart), so this script no longer
   overrides it. Previously this also rewrote delivery text on a timer to track a promo end
   date; that logic was removed to avoid duplicating/contradicting the product description. */
(() => {
  let queued = false;

  const syncOfferMessaging = () => {
    queued = false;

    // Keep the basket-building offer commercial, but remove launchy all-caps shouting.
    document.querySelectorAll('p').forEach((p) => {
      if (p.textContent.includes('COMPLETE THE LOOK & SAVE 10%')) {
        p.innerHTML = '<strong>Complete the look</strong><br><br>Pair any tee with an eligible bottom and 10% is applied to the bottom automatically.<br><br>No code needed.';
      }
    });
  };

  const queueSync = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(syncOfferMessaging);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueSync, { once: true });
  } else {
    queueSync();
  }

  // Shopify morphs cart/PDP sections after variant, quantity and discount updates.
  // Re-run only when the DOM changes so messaging stays accurate without polling.
  const observer = new MutationObserver(queueSync);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
